import React, { useEffect, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import "./dashboardTable.scss";
import {
  Button,
  Checkbox,
  Grid,
  InputBase,
  TablePagination,
  Tooltip,
  Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import DashboardTableSkaleton from "../../../components/Skeletons/DashboardTableSkaleton";
import LeftSideBar from "../../../components/LeftSideBar/LeftSideBar";
import AdministratorHeader from "../../../components/Header/AdministratorHeader";
import {
  clearApprovedBatchesSatus,
  getBatchRejectedDataForColInsertion,
  submitBatchApprovelForColInsertion,
} from "../../../redux/administrator/actions";
import Header from "../../../components/Header/Header";

import CustomizedSnackbars from "../../../components/Snackbars/CustomizedSnackbars";
import Label from "../../../components/Label/Label";
import ProgressBar from "../../../components/ProgressBar";
import { action } from "../../../constants/action";
import SearchIcon from "@mui/icons-material/Search";

const BatchRejection = (props) => {
  const dispatch = useDispatch();

  const apiStatus = useSelector((state) => state?.admin?.apiStatus);
  const batchApprovedStatus = useSelector(
    (state) => state?.admin?.batchApprovedStatus
  );
  const batchesData = useSelector((state) => state?.admin?.batchesData || []);
  const [pageCount, setPageCount] = useState(batchesData?.total_count || 0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [clonedBatchesData, setClonedBatchesData] = useState(
    batchesData.length ? [...batchesData] : []
  );
  const [dataToSubmit, setDataToSubmit] = useState([]);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const [err, setErr] = useState(false);

  useEffect(() => {
    setClonedBatchesData(batchesData.length ? [...batchesData] : []);
  }, [batchesData]);

  useEffect(() => {
    if (batchApprovedStatus && batchApprovedStatus?.loader === false) {
      if (batchApprovedStatus?.apiSuccess === true) {
        setSuccess(true);
        setMessage(batchApprovedStatus?.message);
        dispatch(clearApprovedBatchesSatus());
        dataToSubmit.map((item) => {
          clonedBatchesData.splice(
            clonedBatchesData.findIndex((e) => e?.batch_id === item),
            1
          );
        });

        setClonedBatchesData([...clonedBatchesData]);
        setDataToSubmit([]);
      } else if (batchApprovedStatus?.apiError === true) {
        setErr(true);
        setMessage(batchApprovedStatus?.message);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [batchApprovedStatus, dispatch]);

  useEffect(() => {
    const data = {
      page: page + 1,
      page_size: rowsPerPage,
    };

    dispatch(getBatchRejectedDataForColInsertion(data));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const handlePageChange = (event, value) => {
    setPage(value);
    dispatch(
      getBatchRejectedDataForColInsertion({
        page: value + 1,
        page_size: rowsPerPage,
      })
    );
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value);
    setPage(0);
    setPageCount(batchesData?.total_count);
  };

  const handleChange = (e, index, batch_id) => {
    if (e.target.checked === true) {
      clonedBatchesData[index].status = true;
      setClonedBatchesData([...clonedBatchesData]);

      setDataToSubmit([...dataToSubmit, clonedBatchesData[index]?.batch_id]);
    } else {
      clonedBatchesData[index].status = false;
      setClonedBatchesData([...clonedBatchesData]);

      dataToSubmit.splice(
        dataToSubmit.findIndex((e) => e === batch_id),
        1
      );
      setDataToSubmit([...dataToSubmit]);
    }
  };

  const submit = () => {
    dataToSubmit &&
      dataToSubmit.length &&
      dispatch(submitBatchApprovelForColInsertion(dataToSubmit));
  };

  const onSearch = (word) => {
    let result;

    if (word) {
      const filteredBatches = batchesData?.filter(function (el) {
        return (
          el?.batch_name
            .toString()
            .toLowerCase()
            .indexOf(word.toLowerCase()) !== -1
        );
      });
      result = filteredBatches;
    } else {
      result = batchesData;
    }

    setClonedBatchesData(result);
  };

  return (
    <div>
      <Header />
      <Grid className="sidebar-main" container>
        <Grid item className="sidebar-container">
          <LeftSideBar page="sidebar" />
        </Grid>

        <Grid className="visualization-conatiner" item>
          <AdministratorHeader text="Column Addition Approval" />

          <div className="seatch-bar">
            <div className="search">
              <div className="search-wrapper">
                <SearchIcon />
              </div>
              <InputBase
                id="searchInput"
                className="input-style"
                placeholder={action.SEARCH_BATCH}
                inputProps={{ "aria-label": "search" }}
                onChange={(event) => onSearch(event.target.value)}
              />
            </div>
          </div>

          <div>
            {apiStatus?.loader ? (
              <DashboardTableSkaleton count={7} />
            ) : (
              <>
                {clonedBatchesData?.length > 0 ? (
                  <TableContainer className="visualization-table-container">
                    <Table
                      stickyHeader
                      className="table-output"
                      aria-label="simple table"
                    >
                      <TableHead>
                        <TableRow>
                          {/* <TableCell align="left">Sr.</TableCell> */}
                          <TableCell align="left">Projct Name</TableCell>
                          <TableCell align="left">Batch Name</TableCell>
                          <TableCell align="left">Comment</TableCell>
                          <TableCell align="left">Approve Column</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {clonedBatchesData?.map((list, index) => {
                          return (
                            <>
                              <TableRow key={list?.batch_id}>
                                {/* <TableCell align="left">{index}</TableCell> */}
                                <TableCell align="left">
                                  {list?.project_name}
                                </TableCell>
                                <TableCell align="left">
                                  {list?.batch_name}
                                </TableCell>
                                <TableCell align="left">
                                  <div className="list-wrapper">
                                    <Tooltip title={list?.remark} arrow>
                                      <Typography className="text-overflow">
                                        {list?.remark}
                                      </Typography>
                                    </Tooltip>
                                  </div>
                                </TableCell>

                                <TableCell>
                                  <Checkbox
                                    checked={list?.status ? true : false}
                                    onChange={(e) =>
                                      handleChange(e, index, list?.batch_id)
                                    }
                                    inputProps={{ "aria-label": "controlled" }}
                                  />
                                </TableCell>
                              </TableRow>
                            </>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                ) : (
                  <div className="no-data">
                    <Label
                      text="No Data Found"
                      fontSize="16"
                      fontWeight="600"
                      padding="20px"
                    />
                  </div>
                )}
              </>
            )}
          </div>

          {batchApprovedStatus?.loader === true && <ProgressBar />}

          <Grid container>
            <Grid item sm={8}>
              <TablePagination
                rowsPerPageOptions={[100, 200, 300, 500]}
                component="div"
                count={pageCount}
                page={parseInt(page)}
                onPageChange={handlePageChange}
                rowsPerPage={parseInt(rowsPerPage)}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Grid>

            <Grid className="submit-btn-grid" item sm={4}>
              <Button
                className="submit-btn"
                onClick={submit}
                disabled={dataToSubmit.length === 0}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      {success && (
        <CustomizedSnackbars
          severity="success"
          state={success}
          text={message}
          handleClose={() => setSuccess(false)}
        />
      )}
      {err && (
        <CustomizedSnackbars
          severity="error"
          state={err}
          text={message}
          handleClose={() => setErr(false)}
        />
      )}
    </div>
  );
};
export default BatchRejection;
